import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "align"];
import React from 'react';
import { intrinsicComponent } from '../../utils/functions';
import Styled from './modal-actions.styles';
import { Align } from './types';
var ModalActions = intrinsicComponent(function (_ref, ref) {
  var children = _ref.children,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? Align.Center : _ref$align,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Styled.ModalActions, _extends({}, rest, {
    align: align,
    ref: ref
  }), children);
});
ModalActions.displayName = 'ModalActions';
export default ModalActions;